<div class="container">
    <a *ngIf="parcelInformations.parcel.customerCoBrandingURL" href="{{parcelInformations.parcel.customerCoBrandingURL}}" target="_blank" (click)="generateTagClick()">
        <img src="{{parcelInformations.parcel.customerCoBrandingBannerDesktop}}" dataqsi="partnerLogo">
    </a>
    <a *ngIf="!parcelInformations.parcel.customerCoBrandingURL">
        <img src="{{parcelInformations.parcel.customerCoBrandingBannerDesktop}}" dataqsi="partnerLogo">
    </a>
</div>
